import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getPeopleCount } from './-query/api';
import { SearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/people/_list/workforce/')({
  validateSearch: zodValidator(SearchSchema),
  loader: getPeopleCount
});